// export const ADD_FILTER = 'ADD_FILTER';
// export const REMOVE_FILTER = 'REMOVE_FILTER';
export const CLEAR_ALL_FILTER = 'CLEAR_ALL_FILTER';
export const ADD_FILTER_STATUS = 'ADD_FILTER_STATUS';
export const ADD_FILTER_PRIORITY = 'ADD_FILTER_PRIORITY';
export const ADD_FILTER_LABEL = 'ADD_FILTER_LABEL';
export const ADD_FILTER_ASSIGNEE = 'ADD_FILTERASSIGNEES';
